export default [
  {
    name: 'feistel',
    gitlab: 'https://gitlab.com/feistel',
    merged_mrs: 208,
    category: 'SuperStar',
  },
  {
    name: 'Taukya Noguchi',
    gitlab: 'https://gitlab.com/tnir',
    merged_mrs: 175,
    category: 'SuperStar',
  },
  {
    name: 'Niklas van Schrick',
    gitlab: 'https://gitlab.com/Taucher2003',
    merged_mrs: 136,
    category: 'SuperStar',
  },
  {
    name: 'Ben Bodenmiller',
    gitlab: 'https://gitlab.com/bbodenmiller',
    merged_mrs: 131,
    category: 'SuperStar',
  },
  {
    name: 'Anshul Riyal',
    gitlab: 'https://gitlab.com/anshulriyal',
    merged_mrs: 129,
    category: 'SuperStar',
  },
  {
    name: 'Lee Tickett',
    gitlab: 'https://gitlab.com/leetickett',
    merged_mrs: 111,
    category: 'SuperStar',
  },
  {
    name: 'JeremyWuuuuu',
    gitlab: 'https://gitlab.com/JeremyWuuuuu',
    merged_mrs: 89,
    category: 'SuperStar',
  },
  {
    name: 'Laurent Deketelaere',
    gitlab: 'https://gitlab.com/ali_o_kan',
    merged_mrs: 85,
    category: 'SuperStar',
  },
  {
    name: 'Marco Zille',
    gitlab: 'https://gitlab.com/zillemarco',
    merged_mrs: 74,
    category: 'Star',
  },
  {
    name: 'Shreedhar Bhat',
    gitlab: 'https://gitlab.com/shridharbhat1998',
    merged_mrs: 72,
    category: 'Star',
  },
  {
    name: 'Jonas Wälter',
    gitlab: 'https://gitlab.com/wwwjon',
    merged_mrs: 61,
    category: 'Star',
  },
  {
    name: 'Mohammad Aseem',
    gitlab: 'https://gitlab.com/mhdasm3',
    merged_mrs: 55,
    category: 'Star',
  },
  {
    name: 'Kev',
    gitlab: 'https://gitlab.com/KevSlashNull',
    merged_mrs: 38,
    category: 'Star',
  },
  {
    name: 'Andrew Smith (EspadaV8)',
    gitlab: 'https://gitlab.com/espadav8',
    merged_mrs: 36,
    category: 'Star',
  },
  {
    name: 'Zehua Zhang',
    gitlab: 'https://gitlab.com/zhzhang93',
    merged_mrs: 36,
    category: 'Star',
  },
  {
    name: 'Baodong',
    gitlab: 'https://gitlab.com/icbd',
    merged_mrs: 34,
    category: 'Star',
  },
  {
    name: 'Jonston Chan',
    gitlab: 'https://gitlab.com/JonstonChan',
    merged_mrs: 30,
    category: 'Star',
  },
  {
    name: 'Varghese Jose',
    gitlab: 'https://gitlab.com/varghesejose2020',
    merged_mrs: 28,
    category: 'Star',
  },
  {
    name: 'Anatoli Babenia',
    gitlab: 'https://gitlab.com/abitrolly',
    merged_mrs: 27,
    category: 'Star',
  },
  {
    name: 'Zhiyuan Lu',
    gitlab: 'https://gitlab.com/luzhiyuan.deer',
    merged_mrs: 27,
    category: 'Star',
  },
  {
    name: 'chenqiting',
    gitlab: 'https://gitlab.com/qt-gith',
    merged_mrs: 25,
    category: 'Star',
  },
  {
    name: 'Mao Chao',
    gitlab: 'https://gitlab.com/chaomao',
    merged_mrs: 24,
    category: 'Star',
  },
  {
    name: 'Daniel Schömer',
    gitlab: 'https://gitlab.com/quatauta',
    merged_mrs: 22,
    category: 'Star',
  },
  {
    name: 'David Barr',
    gitlab: 'https://gitlab.com/davebarr',
    merged_mrs: 22,
    category: 'Star',
  },
  {
    name: 'Birger J. Nordølum',
    gitlab: 'https://gitlab.com/MindTooth',
    merged_mrs: 21,
    category: 'Star',
  },
  {
    name: 'Raimund Hook',
    gitlab: 'https://gitlab.com/stingrayza',
    merged_mrs: 21,
    category: 'Star',
  },
  {
    name: 'Deja Norby',
    gitlab: 'https://gitlab.com/dlkeith90',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    name: 'Kyle Edwards',
    gitlab: 'https://gitlab.com/KyleFromKitware',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    name: 'Zubeen',
    gitlab: 'https://gitlab.com/syedzubeen',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    name: 'Piotr Stankowski',
    gitlab: 'https://gitlab.com/trakos',
    merged_mrs: 19,
    category: 'Star',
  },
  {
    name: 'Joseph Jose',
    gitlab: 'https://gitlab.com/josephjose',
    merged_mrs: 18,
    category: 'Star',
  },
  {
    name: 'Kun Qian',
    gitlab: 'https://gitlab.com/qk44077907',
    merged_mrs: 18,
    category: 'Star',
  },
  {
    name: 'Rishabh Gupta',
    gitlab: 'https://gitlab.com/imrishabh18',
    merged_mrs: 17,
    category: 'Star',
  },
  {
    name: 'Song Huang',
    gitlab: 'https://gitlab.com/songhuangcn',
    merged_mrs: 16,
    category: 'Star',
  },
  {
    name: 'Andreas Deicha',
    gitlab: 'https://gitlab.com/TrueKalix',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    name: 'Fabio Huser',
    gitlab: 'https://gitlab.com/fh1ch',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    name: 'Marylette Roa',
    gitlab: 'https://gitlab.com/mbroa04',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    name: 'Mathieu Parent',
    gitlab: 'https://gitlab.com/sathieu',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    name: 'Lennard Sprong',
    gitlab: 'https://gitlab.com/X_Sheep',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    name: 'Martin Tan',
    gitlab: 'https://gitlab.com/mtan-gitlab',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    name: 'See GitLab account @timofurrer',
    gitlab: 'https://gitlab.com/tuxtimo',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    name: 'lyb124553153',
    gitlab: 'https://gitlab.com/lyb124553153',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    name: 'Fabian Schneider',
    gitlab: 'https://gitlab.com/fabsrc',
    merged_mrs: 12,
    category: 'Star',
  },
  {
    name: 'George Tsiolis',
    gitlab: 'https://gitlab.com/gtsiolis',
    merged_mrs: 12,
    category: 'Star',
  },
  {
    name: 'Mehul Sharma',
    gitlab: 'https://gitlab.com/mehulsharma',
    merged_mrs: 12,
    category: 'Star',
  },
  {
    name: 'Linjie Zhang',
    gitlab: 'https://gitlab.com/zhanglinjie',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    name: 'Alexey Zapparov',
    gitlab: 'https://gitlab.com/ixti',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Craig Andrews',
    gitlab: 'https://gitlab.com/candrews',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Jaspreet Singh',
    gitlab: 'https://gitlab.com/jaspreet-3911',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Matthias Baur',
    gitlab: 'https://gitlab.com/m.baur',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Nejc Habjan',
    gitlab: 'https://gitlab.com/nejc',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Steve Mokris',
    gitlab: 'https://gitlab.com/smokris',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Tao Heng',
    gitlab: 'https://gitlab.com/taoheng',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    name: 'Bianca Power',
    gitlab: 'https://gitlab.com/biancapower',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    name: 'Jörg Behrmann',
    gitlab: 'https://gitlab.com/behrmann',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    name: 'Lucas Zampieri',
    gitlab: 'https://gitlab.com/lzampier',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    name: 'Micah Nagel',
    gitlab: 'https://gitlab.com/mjnagel',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    name: 'Shuang Zhang',
    gitlab: 'https://gitlab.com/tonygodspeed92',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    name: 'vincent stchu',
    gitlab: 'https://gitlab.com/vincent_stchu',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    name: 'Aaron',
    gitlab: 'https://gitlab.com/walkafwalka',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'Adithya Krishna',
    gitlab: 'https://gitlab.com/adithyaakrishna',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'Ashvith Shetty',
    gitlab: 'https://gitlab.com/Ashvith',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'Karthik (PK)',
    gitlab: 'https://gitlab.com/parkourkarthik',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'Steven Van der Jeugt',
    gitlab: 'https://gitlab.com/svdj',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'Thomas Chandelle',
    gitlab: 'https://gitlab.com/tchandelle',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'willian.eth',
    gitlab: 'https://gitlab.com/willianpaixao',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    name: 'Afzal Ansari',
    gitlab: 'https://gitlab.com/afzal442',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Akis Maziotis',
    gitlab: 'https://gitlab.com/akis.maziotis',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Asutosh Panda',
    gitlab: 'https://gitlab.com/measutosh',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Dannyel Cardoso da Fonseca',
    gitlab: 'https://gitlab.com/dannyelcf',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Fu Zhang',
    gitlab: 'https://gitlab.com/prajnamas',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Joe Snyder',
    gitlab: 'https://gitlab.com/joe-snyder',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Leni Kadali Mutungi',
    gitlab: 'https://gitlab.com/lenikadali',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Wei Duan',
    gitlab: 'https://gitlab.com/WilsonDuanWei',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'bohdan-barylo',
    gitlab: 'https://gitlab.com/bohdan-barylo',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    name: 'Abhi Arora',
    gitlab: 'https://gitlab.com/abhi_arora',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Adrián López Calvo',
    gitlab: 'https://gitlab.com/AdrianLC',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Batuhan Wilhelm',
    gitlab: 'https://gitlab.com/batu',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'David Elizondo',
    gitlab: 'https://gitlab.com/daelmo',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Elan Ruusamäe',
    gitlab: 'https://gitlab.com/glensc',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Em Karisch',
    gitlab: 'https://gitlab.com/QuingKhaos',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Guillaume Chauvel',
    gitlab: 'https://gitlab.com/guillaume.chauvel',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Kevin Hall',
    gitlab: 'https://gitlab.com/kevinhall',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Nico Bollen',
    gitlab: 'https://gitlab.com/bollenn',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Philipp Böschen',
    gitlab: 'https://gitlab.com/Deichindianer',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Ron Gebauer',
    gitlab: 'https://gitlab.com/cgm-rgb',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Rostyslav Safonov',
    gitlab: 'https://gitlab.com/knockfog',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    name: 'Wesley Beary',
    gitlab: 'https://gitlab.com/geemus',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
];
